module.exports = __webpack_public_path__ + "assets/img/Ranking.41904592.png";